
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { empty, singleton, append, delay, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { createObj, int32ToString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Button } from "../../Components/Button.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import { RouterModule_encodeParts, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { toArray as toArray_1, empty as empty_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Table } from "../../Widgets/Table/Table.js";
import { unwrapDispolistId } from "../../Shared/Helper.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

function OverviewTable(props) {
    let elems_2, elems_1, elems, Label;
    const t = useTranslation()[0];
    const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("sumTools", "", t("dispolist.sum_tools"), (dto_1) => (new CellContent(0, [int32ToString(dto_1.SumTools)])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("sumToolsWithQuantity", "", t("dispolist.sum_tools_with_quantity"), (dto_2) => (new CellContent(0, [int32ToString(dto_2.SumToolsWithQuantity)])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("sumConsumables", "", t("dispolist.sum_consumables"), (dto_3) => (new CellContent(0, [int32ToString(dto_3.SumConsumables)])), "text", "text")), delay(() => (props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (dto_4) => (new CellContent(0, [defaultArg(dto_4.BusinessUnitName, "")])), "select", "text")) : empty())))))))))));
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "pb-2"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["grow"]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3"])], (elems = [createElement(Button, (Label = t("settings.create_new_dispolist"), {
        ComponentState: "enabled",
        Icon: Shipment_Add(),
        Label: Label,
        OnClick: () => {
            RouterModule_nav(ofArray(["inventory-lists", "new"]), 1, 1);
        },
        TestId: "add-new-inventory-button",
        Variant: "primary",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(Table, {
        ColumnDefinitions: columnDefinitions,
        Controls: empty_1(),
        Options: {
            BorderStyle: "full",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            OnRowClick: new OnTableRowClick$1(1, [(row) => RouterModule_encodeParts(ofArray(["inventory-lists", unwrapDispolistId(row.Id)]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: toArray_1(props.Dispolists),
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function OverviewView(props) {
    const state_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.UserData, undefined)[0];
    const matchValue = state_1.Dispolists;
    const matchValue_1 = state_1.AccountSettings;
    let matchResult, accountSettings, dispolists;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_1.fields[0];
        dispolists = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(OverviewTable, {
                AccountSettings: accountSettings,
                Dispolists: dispolists,
            });
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

